export const DropdownPillTestAttributes = {
    label: 'dropdown-pill-label',
    selectedLabel: 'dropdown-pill-selected-label',
    tooltip: 'dropdown-pill-tooltip',
    deleteButton: 'dropdown-pill-delete-button',
    sheet: 'dropdown-pill-sheet',
};
